import { css, styled } from 'next-yak';

import { SkeletonRectangle } from '../';

type ImageTransientProps = {
  $height?: string;
  $width?: string;
};

// *** Components ***
export const Image = styled(SkeletonRectangle)<ImageTransientProps>`
  ${({ $height }) =>
    $height &&
    css`
      height: ${() => $height};
    `};
  ${({ $width }) =>
    $width &&
    css`
      width: ${() => $width};
    `};
`;
